import './utilities/cryptoPolyfill.js';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import './index.css';
import App from './App.jsx';

// --- Deploy resilience: auto-recover from stale code-split chunks ---
// Each deploy replaces the hashed route chunks and removes the previous build's.
// A client still running an older index.html will request an old chunk on
// navigation; that request now 404s (see public/_redirects), so the dynamic
// import() fails and Vite fires `vite:preloadError`. Reload once to pull the
// fresh index.html, which references the current chunk hashes. A short
// time-guard prevents reload loops if a reload doesn't resolve it.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'chunk-reload-at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last > 10000) {
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  }
});

// --- Stop the scroll wheel changing number fields ---
// Chrome and Edge step a focused number input by one `step` per wheel click
// while the pointer is over it. Scrolling past a price that was just typed
// quietly changed it: credit note CN-35838 went out at £384.96 instead of
// £385.00 (four clicks of 1p). Dropping focus first means the wheel scrolls
// the page instead. Typing, the arrow keys and the spinner still work.
document.addEventListener(
  'wheel',
  event => {
    const field = document.activeElement;
    if (field?.type === 'number' && field === event.target) field.blur();
  },
  { passive: true }
);

createRoot(document.getElementById('root')).render(<App />);
